import {
  GET_COLLECTION,
  GET_COLLECTION_SUCCESS,
  GET_COLLECTION_ERROR,
  
  CREATE_COLLECTION_NEW_RECORD,
  CREATE_COLLECTION_NEW_RECORD_SUCCESS,
  CREATE_COLLECTION_NEW_RECORD_ERROR
} from "../actions";

const INIT_STATE = {
  collectionId: null,
  collection: null,
  collectionDetailsError: "",
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
        case CREATE_COLLECTION_NEW_RECORD:
      return { ...state, loading: true, error: "", record: action.payload.newRecord };
    case CREATE_COLLECTION_NEW_RECORD_SUCCESS:
      return { ...state, loading: false, error: "", record: action.payload, isNewRecordPanelShown: false };
    case CREATE_COLLECTION_NEW_RECORD_ERROR:
      return { ...state, loading: false, error: action.payload.message };

    case GET_COLLECTION:
      return {
        ...state,
        loading: true,
        collectionId: action.payload.collectionId,
        collectionDetailsError: "",
      };
    case GET_COLLECTION_SUCCESS:
      
      return {
        ...state,
        loading: false,
        collectionDetailsError: "",
        collection: action.payload.collection
      };
    case GET_COLLECTION_ERROR:
      return { ...state, loading: false, collectionDetailsError: action.payload ? action.payload.message : "" };
    default:
      return { ...state };
  }
};
